const constants = {
    SAVE_OVERLAY: 750
};

export { constants as TIMEOUT_CONSTANTS };
